module.exports = __webpack_public_path__ + "img/work2022-chi-retrieval.dd73aabe.png";